import { Box } from "../Box"
import { TableProps, Table, TableDataTestIds } from "../Table"
import { LimitBarProps, LimitBar } from "../LimitBar"
import * as styles from "./tableStyles"

export type TableWithLimitBarDataTestIds = {
  table?: TableDataTestIds
  limitBar?: string
}

type Props<T extends Record<string, unknown>> = Readonly<{
  dataTestIds?: TableWithLimitBarDataTestIds
  limitBarProps: LimitBarProps
}> &
  TableProps<T>

export const TableWithLimitBar = <T extends Record<string, unknown>>({
  containerCss,
  dataCount,
  handlePagination,
  dataTestIds,
  limitBarProps,
  ...props
}: Props<T>) => (
  <Box css={styles.makeContainerStyle(containerCss)}>
    <Table dataTestIds={dataTestIds?.table} {...props} />
    <LimitBar dataTestIds={{ root: dataTestIds?.limitBar }} {...limitBarProps} />
  </Box>
)

TableWithLimitBar.defaultProps = {
  dataTestIds: undefined,
}
